import './asserts/index.less'

// @ts-ignore
import table from './module/index'

export default table
